import { CheckListItemRow } from "@poseidon/ui/components/CheckListTable";

export function SailorCheckListItemRow({
  status,
  label,
  tooltip,
  applicantType,
  manageLink,
  manageText,
}) {
  const suffix = applicantType ? ` (${applicantType} applicant)` : "";
  const suffixShort = applicantType ? ` (${applicantType})` : "";
  return (
    <CheckListItemRow
      status={status}
      label={`${label}${suffix}`}
      tooltip={`${tooltip}${suffix}`}
      manageLink={manageLink}
      manageText={`${manageText}${suffixShort}`}
    />
  );
}
